import { gql } from '@apollo/client';
import { BACKGROUND_JOB_FIELDS } from 'src/graphql/entities/background-job/background-job.operations';
import { DTOOLS_AUTH_DETAILS_FRAGMENT } from './dtools.fragments';

export const DTOOLS_AUTHENTICATE = gql`
  mutation DtoolsAuthenticate($params: DtoolsAuthenticateInput!) {
    dtoolsAuthenticate(params: $params) {
      authDetails {
        id
        ...DtoolsAuthDetails
      }
    }
  }
  ${DTOOLS_AUTH_DETAILS_FRAGMENT}
`;

export const DTOOLS_REVOKE_AUTHENTICATION = gql`
  mutation DtoolsRevokeAuthentication($params: DtoolsRevokeAuthenticationInput!) {
    dtoolsRevokeAuthentication(params: $params) {
      partnerId
    }
  }
`;

export const GET_DTOOLS_AUTH_DETAILS = gql`
  query GetDtoolsAuthConnections($params: GetDtoolsAuthDetailsInput!) {
    getDtoolsAuthDetails(params: $params) {
      authDetails {
        id
        ...DtoolsAuthDetails
      }
    }
  }
  ${DTOOLS_AUTH_DETAILS_FRAGMENT}
`;

export const GET_DTOOLS_PROJECTS = gql`
  query GetDtoolsProjects($params: GetDtoolsProjectsInput!) {
    getDtoolsProjects(params: $params) {
      projects {
        id
        name
        number
        clientName
        createdDate
        modifiedDate
        isArchived
      }
      totalProjects
    }
  }
`;

export const GET_DTOOLS_PROJECT_DETAILS = gql`
  query GetDtoolsProjectDetails($params: GetDtoolsProjectDetailsInput!) {
    getDtoolsProjectDetails(params: $params) {
      content
    }
  }
`;

export const START_DTOOLS_PROJECT_IMPORT_JOB = gql`
  mutation StartDtoolsProjectImportJob($params: StartDtoolsProjectImportJobInput!) {
    startDtoolsProjectImportJob(params: $params) {
      ...BackgroundJobFields
    }
  }
  ${BACKGROUND_JOB_FIELDS}
`;
